/* eslint-disable no-undef */

window.$ = window.jQuery;

import VanillaCalendar from "@uvarov.frontend/vanilla-calendar";
import 'slick-carousel';

require('@fancyapps/fancybox/dist/jquery.fancybox');

function visualSlider() {
    jQuery('.visual-slider').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        edgeFriction: 0.02,
        autoplaySpeed: 2500,
    });
}

function gallery() {
    // eslint-disable-next-line no-shadow
    const gallery = jQuery('.gallery-block-items').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.gallery-block-nav',
    });
    jQuery('.gallery-block-nav').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.gallery-block-items',
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });
    gallery.on('beforeChange', function () {
        jQuery('.gallery-block-nav-item .nr').hide();
    });
}

function contentJS() {
    let hash = window.location.hash;
    if (hash) {
        jQuery(".wp-block-yoast-faq-block .schema-faq-section").each(function () {
            if (`#${jQuery(this).attr('id')}` === hash) {
                jQuery(this).addClass('active');
            }
        });
    } else {
        jQuery(".wp-block-yoast-faq-block .schema-faq-section:first-child").each(function () {
            jQuery(this).addClass('active');
        });
    }

    jQuery(window).on('hashchange', () => {
        hash = window.location.hash;
        if (hash) {
            jQuery(".wp-block-yoast-faq-block .schema-faq-section").each(function () {
                if (`#${jQuery(this).attr('id')}` === hash) {
                    jQuery(this).addClass('active');
                } else {
                    jQuery(this).removeClass('active');
                }
            });
        }
    });

    jQuery(".wp-block-yoast-faq-block .schema-faq-section .schema-faq-question").each(function () {
        jQuery(this).click(function (e) {
            e.preventDefault();
            jQuery(".wp-block-yoast-faq-block .schema-faq-section").removeClass('active');
            jQuery(this).parent().addClass('active');
        });
    });

    jQuery(".entry-content .wp-block-gallery .wp-block-image a").each(function () {
        jQuery(this).attr('data-fancybox', 'gallery');
    });
}

function eventsFilter() {
    jQuery('.events-filters select').change(function () {
        jQuery('.events').addClass('fade');
        jQuery('.events-filters form').submit();
    });
}

function calendar() {
    // eslint-disable-next-line no-shadow
    const calendar = new VanillaCalendar('#calendar', calendar_options);
    calendar.init();
}

function eventGallery() {
    // eslint-disable-next-line no-shadow
    const eventGallery = jQuery('.event-gallery');
    // eslint-disable-next-line no-shadow
    const gallery = eventGallery.find('.gallery');
    const photo = eventGallery.find('.photo');
    const video = photo.find('.video');
    const iframe = video.find('iframe');
    const imageLinks = gallery.find('a.image');
    const youtubeLinks = gallery.find('a.youtube');
    const image = photo.find('img');

    imageLinks.click(function (e) {
        e.preventDefault();
        const thisLink = jQuery(this);
        const thisHref = thisLink.attr('href');

        video.hide();
        iframe.attr('src', '');
        gallery.find('a').removeClass('active');
        thisLink.addClass('active');
        image.attr('src', thisHref).show();
    });

    youtubeLinks.click(function (e) {
        e.preventDefault();
        const thisLink = jQuery(this);
        const thisHref = thisLink.attr('href');

        image.hide();
        iframe.attr('src', thisHref);
        video.show();
    });
}

function loadPosts() {
    jQuery('.btn-more-ajax').click(function (e) {
        e.preventDefault();
        const data_this = jQuery(this);
        const data_load_type = jQuery(this).attr('data-load-type');
        const data_load_start = parseInt(jQuery(this).attr('data-load-start'));
        const data_load_more = parseInt(jQuery(this).attr('data-load-more'));
        jQuery.ajax({
            data: {
                data_load_type,
                data_load_start,
                data_load_more,
            },
            type: 'POST',
            url: theme.ajax_url + '?action=load_posts',
            beforeSend() {
                data_this.css("pointer-events", "none");
            },
            error() {
                data_this.css("pointer-events", "all");
            },
            success(response) {
                if (response.valid) {
                    jQuery(`.container .${data_load_type}`).append(response.html);
                    jQuery(`.container .${data_load_type}-nr`).html(data_load_start+data_load_more);
                    data_this.css("pointer-events", "all");
                    data_this.attr("data-load-start", (data_load_start + data_load_more));
                    if (response.last) {
                        data_this.hide();
                    }
                } else {
                    data_this.hide();
                }
            },
        });
    });
}

function mobileNav() {
    jQuery('.mobile-nav').on('click', function (e) {
        e.preventDefault();
        const header_menu = jQuery('.site-header-items .primary-navigation');
        if (header_menu.hasClass('active')) {
            header_menu.slideUp();
            header_menu.removeClass('active');
            jQuery('body').removeClass('menu-active');
        } else {
            header_menu.slideDown();
            header_menu.addClass('active');
            jQuery('body').addClass('menu-active');
        }
    });

    jQuery('.toggle-sub-menu').on('click', function () {
        const parent = jQuery(this).parent();
        if (parent) {
            parent.toggleClass('sub-menu-open');
        }
    });
}

function eventMore() {
    const content_height = jQuery('.event-content').height();
    if (content_height > 500) {
        jQuery('.event-content').addClass('big');
    }
    jQuery('.btn-toggle-more').on('click', function (e) {
        e.preventDefault();
        jQuery(this).toggleClass('active');
        jQuery('.event-content.big').toggleClass('big-full');
    });
}

function logosSlider() {
    jQuery('.logos-list').slick({
        dots: true,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 6,
        slidesToScroll: 6,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
        ],
    });
}

function tabs() {
    jQuery('.tabs .tab a').on('click', function (e) {
        e.preventDefault();
        const img_url = jQuery(this).attr('data-href');
        jQuery('.tabs .tab').removeClass('active');
        jQuery(this).parent().addClass('active');
        jQuery('.tabs-content-item').removeClass('active');
        jQuery(img_url).addClass('active');
    });
    jQuery('.tabs-content .plans-nav a').on('click', function (e) {
        e.preventDefault();
        const img_url = jQuery(this).attr('data-href');
        jQuery('.tabs-content .plans-nav a').removeClass('active');
        jQuery(this).addClass('active');
        jQuery('.tabs-content .plans-image img').attr('src', img_url);
    });
}

function menuActiveItems() {
    const linkHash = (href) => {
        if (href) {
            return href.split('#').length > 1 ? `#${href.split('#')[1].toLowerCase().trim()}` : '';
        }
        return '';
    };

    const updateActive = (elm, currentHash = window.location.hash) => {
        const href = elm.attr('href');
        if (href) {
            const hash = linkHash(href);
            if (hash === currentHash) {
                elm.parent().addClass('current-menu-item');
            } else {
                elm.parent().removeClass('current-menu-item');
            }
        }
    };

    if (window.location.hash) {
        jQuery('.menu-wrapper').find('a').each(function () {
            updateActive(jQuery(this));
        });
    }

    jQuery(window).on('hashchange', () => {
        if (window.location.hash) {
            jQuery('.menu-wrapper').find('a').each(function () {
                updateActive(jQuery(this));
            });
            setTimeout(function () {
                jQuery('html, body').stop().animate({
                    scrollTop: jQuery(window.location.hash).offset().top - 150,
                }, 200);
            }, 500);
        }
    });
}

function jsSelect() {

    const buildSelect = (element) => {

        if (element.querySelector('.js-select')) {
            return;
        }

        const select = element.querySelector('select');
        select.style.display = 'none';

        const wrapper = document.createElement('div');
        wrapper.classList = 'js-select';
        select.parentNode.insertBefore(wrapper, select);
        wrapper.appendChild(select);

        const placeholder = select.options[select.selectedIndex].text;
        select.insertAdjacentHTML('afterend', '<ul class="dropdown-list" style="display: none"></ul>')
        select.insertAdjacentHTML('beforebegin', `<div class="selected">${placeholder}</div>`)

        const defaultSelected = element.getAttribute('data-select-selected');
        const selected = element.querySelector('.selected');
        const ul = element.querySelector('ul.dropdown-list');
        const jsSelect = element.querySelector('.js-select');

        if (defaultSelected) {
            select.value = defaultSelected;
        }

        updateSelect(element);

        document.addEventListener('click', (e) => {
            if ( !jsSelect.contains(e.target) ) {
                ul.style.display = 'none';
                jsSelect.classList.remove('select-open');
            }
        });

        const selectedOption = select.options[select.selectedIndex];
        selected.value = selectedOption && selectedOption.text ? selectedOption.text : defaultSelected;
        selected.addEventListener('click', (e) => {
            if (e.defaultPrevented) return;
            ul.style.display = 'block';
            jsSelect.classList.add('select-open');
        });

        MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
        const observer = new MutationObserver(() => {
            updateSelect(element);
        });

        observer.observe(select, {
            childList: true,
        });
    }

    const updateSelect = (element) => {
        let html = '';
        const ul = element.querySelector('ul.dropdown-list');
        const select = element.querySelector('select')
        const selected = element.querySelector('.selected');

        ul.replaceChildren();
        select.querySelectorAll('option').forEach((option) => {
            const name = option.innerText;
            const value = option.value ?? name;
            const disabled = option.disabled;
            let attributes = option.hasAttribute('selected') ? `data-selected="true"` : '';
            attributes += value ? ` data-value="${value.trim()}"` : '';
            attributes += name ? ` data-name="${name.trim()}"` : '';
            attributes += disabled ? ' data-disabled' : '';

            html += `<li ${attributes}>${name}</li>`;
        });
        ul.insertAdjacentHTML('afterbegin', html);

        element.querySelectorAll('ul.dropdown-list li').forEach((li) => {
            li.addEventListener('click', () => {
                const value = li.getAttribute('data-value');
                select.value = value;
                selected.value = li.getAttribute('data-name');
                selected.setAttribute('data-value', value);

                select.dispatchEvent(new Event('change'));
                selected.dispatchEvent(new Event('change'));

                ul.style.display = 'none';
                element.querySelector('.js-select').classList.remove('select-open');
                setTimeout(() => {
                    ul.style.display = 'none';
                    element.querySelector('.js-select').classList.remove('select-open');
                }, 100);
            });
        });
    }

    const destroySelect = (element) => {
        const select = element.querySelector('select');
        const selected = element.querySelector('.selected');
        const ul = element.querySelector('ul.dropdown-list');
        const jsSelect = element.querySelector('.js-select');

        if (selected) {
            selected.remove();

            const parent = jsSelect.parentNode;
            while (jsSelect.firstChild) {
                parent.insertBefore(jsSelect.firstChild, jsSelect);
            }
            parent.removeChild(jsSelect);
        }

        if (ul) {
            ul.remove();
        }

        select.style.display = '';
    }

    document.querySelectorAll('[data-select]').forEach((element) => {
        buildSelect(element);
    });
}

function popup() {
    const body = jQuery('body');
    const popupElm = jQuery('.popup');
    const storage = window.sessionStorage;
    const params = new URLSearchParams(window.location.search);
    let disablePopups = false;
    if (params.has("nopopups")) {
        params.delete("nopopups");
        if (params) {
            history.pushState(null, null, `?${params.toString()}`);
        } else {
            history.pushState(null, null, params.toString());
        }
        disablePopups = true;
    }

    popupElm.each(function () {
        const currentPopup = jQuery(this);
        const delay = currentPopup.attr('data-delay') ?? 5;
        if (!disablePopups) {
            setTimeout(function () {
                const id = currentPopup.attr('data-popup');
                if (!storage.getItem(`popup-${id}`)) {
                    currentPopup.addClass('popup--open');
                    setTimeout(function () {
                        body.addClass('has-popup-open');
                    }, 500);
                }
            }, delay * 1000);
        } else {
            const id = currentPopup.attr('data-popup');
            storage.setItem(`popup-${id}`, '1');
        }
    });

    popupElm.find('.popup-close, a').on('click', function () {
        if (body.hasClass('has-popup-open')) {
            const closestPopup = jQuery(this).closest('.popup').first();
            const id = closestPopup.attr('data-popup');
            closestPopup.removeClass('popup--open');
            if (jQuery('.popup--open').length === 0) {
                body.removeClass('has-popup-open');
                storage.setItem(`popup-${id}`, '1');
            }
        }
    });

    popupElm.on('click', function (e) {
        if (e.target !== this) {
            return;
        }

        if (body.hasClass('has-popup-open')) {
            jQuery(this).removeClass('popup--open');
            const id = jQuery(this).attr('data-popup');
            storage.setItem(`popup-${id}`, '1');

            if (jQuery('.popup.popup--open').length === 0) {
                body.removeClass('has-popup-open');
            }
        }
    });
}

jQuery(document).ready(function () {
    "use strict";

    gallery();
    eventGallery();
    eventMore();
    visualSlider();
    contentJS();
    eventsFilter();
    loadPosts();
    mobileNav();
    logosSlider();
    tabs();
    menuActiveItems();
    popup();
    jsSelect();

    if (typeof calendar_options !== 'undefined') {
        calendar();
    }

    jQuery(window).scroll(function () {
        const header = jQuery('body');
        const scroll = jQuery(window).scrollTop();
        if (scroll >= 70) {
            header.addClass('sticky');
        } else {
            header.removeClass('sticky');
        }
    });

    jQuery.ajaxPrefilter(function (options, originalOptions, jqXHR) {
        if (options.dataType === 'json') {
            var lang = window.location.pathname.split('/')[1];
            if (lang && lang !== 'lt') {
                options.url += (options.url.indexOf('?') === -1 ? '?' : '&') + 'glang=' + lang +'&lang=' + lang;
            }
        }
    });
});
